// extracted by mini-css-extract-plugin
module.exports = {"sm":"0","md":"46.875rem","lg":"63.9375em","xl":"80em","navigation":"Navigation_navigation__eSStv","navigation__logo":"Navigation_navigation__logo__iGxMi"};